import React, { useState } from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import LzSApp from '@lz-app/App';
import useLzFApiCall from '@lz-services/Api';
import { useLzOnMount } from '@lz-services/Hooks';
import LzXInfoBox from '@lz-widgets/InfoBox';
import LzXSpinner from '@lz-components/commons/Spinner';

function UserDashboardScreen() {

  const [dashboardData, setDashboardData] = useState(null);

  const apiCall = useLzFApiCall();

  const load = async () => {
    const data = await apiCall('dashboard-data');

    if (data) {
      setDashboardData(data);
    }
  };

  // Call only for the first time when component is initially loaded
  useLzOnMount(() => {
    load();
  });

  // console.log('DD', dashboardData);

  return (
    <LzSApp.WrapperTemplate private screenTitle="Dashboard">

      {dashboardData ?
        <React.Fragment>
          <Container>
            <Grid container spacing={2}>
              {dashboardData?.stats &&
                <Grid size={{ xs: 9 }}>
                  <h2>System Statistics</h2>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox primary dark heading="Grains" count={dashboardData.stats.grains || 0} route='/params/grains' />
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox red dark heading="Meshes" count={dashboardData.stats.meshes || 0} route='/params/meshes' />
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox green dark heading="Bonds" count={dashboardData.stats.bonds || 0} route='/params/bonds' />
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox blue dark heading="Other Ingredients" count={dashboardData.stats.other_ingredients || 0} route='/params/other-ingredients' />
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox purple dark heading="Weighing Cards" count={dashboardData.stats.weighing_cards || 0} route='/content/weighing-cards' />
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <LzXInfoBox secondary dark heading="Users" count={dashboardData.stats.users || 0} route='/system/users' />
                    </Grid>
                  </Grid>
                </Grid>
              }
            </Grid>
          </Container>
        </React.Fragment>
        :
        <LzXSpinner />
      }

    </LzSApp.WrapperTemplate>
  );
}

export default UserDashboardScreen;
